<template>
    <div id="loading">
        <v-progress-circular class="progressbar"
                             indeterminate
                             size="50"
                             width="6">
        </v-progress-circular>
    </div>
</template>

<script>
    export default {
        name: "Loading"
    }
</script>